module.exports = __webpack_public_path__ + "fonts/fa-solid-900.605ed792.ttf";